<template>
  <section class="featured-deck empty">
    <div class="featured__img bg-gray-200 flex flex-col justify-center items-center text-gray-500 rounded-lg">
      <ArrowPathIcon class="w-8 h-8 mb-2" />
      <h2 class="m-0 text-sm md_text-md lg_text-lg xl_text-xl">Featured 3D Presentation is coming soon.<br />Please check back again later.</h2>
    </div>
    <div class="lg_mt-4 filler-blocks">
      <p />
      <p />
      <p />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { ArrowPathIcon } from '@heroicons/vue/24/outline'
</script>

<style lang="stylus" scoped>
.featured__img
  aspect-ratio 16 / 9
.filler-blocks p
  @apply my-2 h-5 w-full rounded-md bg-gray-200
  &:last-child
    @apply w-3/4
@screen md
  .filler-blocks p
    @apply my-3
@screen lg
  .filler-blocks p
    @apply h-6
@screen xl2
  .filler-blocks p
    @apply h-8 my-4
</style>
